module.exports = __webpack_public_path__ + "static/media/Dodge.3214ddaa.png";